
export const SET_SLIDER_INDEX = 'SET_SLIDER_INDEX'
export const setSliderIndex = (data) => {
  return ({ type: SET_SLIDER_INDEX, data })
}
